import '../css/saltire.css'

const FooterContainer = (props) => {
    return (
        <footer id="footer" className="footer" role="contentinfo">
            <div className="container">
                <div aria-label="copyright" className="copyright">
                    <ul className="remove-underline">
                        {/* <li><a href="http://novascotia.ca/news/rss/">RSS</a></li> */}
                        <li key="twitter"><a href="https://www.twitter.com/nsgov">Twitter</a></li>
                        <li key="youtube"><a href="https://www.youtube.com/nsgov">Youtube</a></li>
                        <li key="facebook"><a href="https://www.facebook.com/nsgov">Facebook</a></li>
                    </ul>
                    
                    <ul className="remove-underline">
                        <li key="privacy"><a href="http://novascotia.ca/cns/privacy/">Privacy</a></li>
                        <li key="terms"><a href="http://novascotia.ca/terms/">Terms</a></li>
                        {/* <li><a href="http://novascotia.ca/cns/privacy/cookies/">Cookies</a></li> */}
                    </ul>

                    <div><small>Crown copyright © Government of <span className="word-break-together">Nova Scotia.</span></small></div>
                </div>
            </div>
        </footer>
    )
}

export default FooterContainer